import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/Card.tsx';
import { ClientAcceptanceVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import ChangeSummaryTable from './ChangeSummaryTable.tsx';
import ClientAcceptanceBrandBar from './ClientAcceptanceBrandBar.tsx';
import ClientAcceptanceIntro from './ClientAcceptanceIntro.tsx';
import ClientAcceptanceBalancePanel from './ClientAcceptanceBalancePanel.tsx';
import ClientAcceptanceDocumentList from './ClientAcceptanceDocumentList.tsx';
import ClientAcceptanceActions from './ClientAcceptanceActions.tsx';

/** Rynna bloków wewnątrz karty — ta sama, którą trzymają nagłówek i stopka. */
const blockGutterClass = '@max-[700px]:mx-4 mx-[26px] mt-4';

interface ClientAcceptancePreviewCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  view: ClientAcceptanceVm;
}

/**
 * Wierna kopia strony spod linku z maila: bez kwot cząstkowych i bez mechaniki
 * paczek — zapisujący widzi wyłącznie to, co zmienia się w jego rezerwacji.
 *
 * 880 px to szerokość tamtej strony; poniżej tego podgląd zwęża się razem
 * z ekranem, zamiast wypychać kolumnę obok.
 */
const ClientAcceptancePreviewCard = ({
  view,
  className,
  ...props
}: ClientAcceptancePreviewCardProps) => (
  <Card
    className={cn(
      '@container w-full max-w-[880px] overflow-hidden min-[1200px]:shrink-0',
      className,
    )}
    {...props}
  >
    <ClientAcceptanceBrandBar bookingCode={view.bookingCode} />
    <ClientAcceptanceIntro view={view} />

    <ChangeSummaryTable variant="client" groups={view.groups} />

    <ClientAcceptanceBalancePanel
      className={blockGutterClass}
      balance={view.balance}
      settlementDescription={view.settlementDescription}
    />

    <ClientAcceptanceDocumentList
      className={blockGutterClass}
      documents={view.documents}
    />

    <ClientAcceptanceActions hasDocuments={view.documents.length > 0} />
  </Card>
);

export default ClientAcceptancePreviewCard;
